import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareAiPlanningPlanRoute: InvariantJiraRoute = {
	name: 'software-ai-planning-plan',
	path: '/jira/software/projects/:projectKey/ai-planning/:planId',
	exact: true,
};
